import { createComponent } from '@carvana/vdp-components';
import classNames from 'classnames';
import React from 'react';

type OwnProps = React.HtmlHTMLAttributes<HTMLDivElement> & {
  text: string;
  border?: boolean;
  bgColor: string;
  bigTag?: boolean;
  blueText?: boolean;
};

const Wrapper = createComponent('div', {
  className:
    'flex font-bold h-[20px] items-center leading-[16px] px-4 rounded text-[12px] w-fit'
});

const Tag = ({
  bgColor,
  border = false,
  text,
  bigTag = false,
  blueText = false,
  ...props
}: OwnProps) => (
  <Wrapper
    className={classNames(
      { '!py-8 !px-16 !text-sm': bigTag },
      { 'border border-grey-3': border },
      { 'text-white': !blueText },
      { 'text-blue-6': blueText },
      bgColor
    )}
    {...props}
  >
    {text}
  </Wrapper>
);

export default Tag;
